export const AUTOPILOT_NAMESPACE = 'autopilot';
export const CLAIM_NAMESPACE = 'claim';
export const COMMIT_NAMESPACE = 'commit';
export const EDIT_PURCHASE_NAMESPACE = 'editPurchase';
export const SHARED_NAMESPACE = 'shared';



// WEBPACK FOOTER //
// ./src/actions/projections.js